import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { GDPRService } from './../shared/gdpr.service';
import { ZCOOKIE, TEXT } from './../app.const';


@Injectable()
export class GDPRManager {
  addId: string;
  platformType: string;
  status: string;
  recaptchaKey: string;
  constructor(public gdprService: GDPRService, public router: Router) {
    this.recaptchaKey = this.gdprService.getRecaptchaKey();
  }

  private handleError(err) {
    if (err.status === 401) {
      this.reAuthenticate();
    } else {
      return Promise.reject(err);
    }
  }

  private handleResponse(promise) {
    return promise
      .catch(this.handleError.bind(this));
  }

  handleRoute(params) {
    if (params && params['addId'] && (params['platformType'] === TEXT.platformAndroid || params['platformType'] === TEXT.platformIOS)) {
      this.addId = params['addId'];
      this.platformType = params['platformType'];
    } else {
      const cookie = this.getCookie(ZCOOKIE);
      if (cookie) {
        this.addId = cookie;
        this.platformType = TEXT.webPlatform;
      } else {
        this.router.navigate(['/error']);
      }
    }
  }

  getCookie(cname) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${cname}=`);
    return parts.length === 2 ? parts.pop().split(';').shift() : '';
  }
  getUserStatus() {
    return this.handleResponse(this.gdprService.getUserStatus());
  }

  exchangeToken() {
    return this.handleResponse(this.gdprService.getExchangedToken(this.platformType, this.addId));
  }

  getUserData() {
    return this.gdprService.getUserData();
  }

  removeUserData() {
    return this.gdprService.removeUserData();
  }

  emailReport(payload) {
    return this.gdprService.emailReport(payload);
  }

  reAuthenticate(params?) {
    if (this.platformType && this.addId) {
      this.router.navigate(['/authentication'], { queryParams: this.getParams() });
    } else if (params && params['addId'] && params['platform']) {
      this.router.navigate(['/authentication'], { queryParams: { platformType: params['platformType'], addId: params['addId'] } });
    } else {
      this.router.navigate(['/authentication']);
    }
  }
  setZToken(token) {
    this.gdprService.setZToken(token);
  }

  setGToken(token) {
    this.gdprService.setGToken(token);
  }

  getZToken() {
    return this.gdprService.getZToken();
  }

  getGToken() {
    return this.gdprService.getGToken();
  }

  refresh() {
    this.router.navigate(['/authentication']);
  }

  getParams() {
    if (this.platformType === TEXT.platformAndroid || this.platformType === TEXT.platformIOS) {
      return {
        platformType: this.platformType,
        addId: this.addId
      };
    } else {
      return {};
    }
  }

  getSplOptoutUrl() {
    return this.gdprService.getSplOptoutUrl();
  }
}



// WEBPACK FOOTER //
// ./src/app/managers/gdpr.manager.ts